import { useQuery } from "@tanstack/react-query";
import { buildParams } from "/app/src/helpers";
import { taskService } from "/app/src/services";
import { Task } from "/app/src/models";
import { useCallback } from "react";

/**
 * Hook to get logs, logsCount, and isLoading for a given set of query params
 */
export function useTasks(
  queryParams: { [key: string]: string | number },
  queryCountParams: { [key: string]: string | number },
  refresh,
) {
  const {
    data: tasks,
    isLoading,
    refetch: refetchTasks,
  } = useQuery({
    queryKey: ["tasks", queryParams],
    queryFn: () => {
      return taskService.getAll(buildParams(queryParams));
    },
    initialData: { tasks: [] },
    select: (data: { tasks: Task[] }) => {
      return data.tasks;
    },
    refetchInterval: refresh ? 10000 : false,
  });

  const { data: tasksCount, refetch: refetchTasksCount } = useQuery({
    queryKey: ["tasksCount", queryCountParams],
    queryFn: () => {
      return taskService.getCount(buildParams(queryCountParams));
    },
    initialData: { count: 0 },
    select: (data: { count: number }) => {
      return data.count;
    },
    refetchInterval: refresh ? 10000 : false,
  });

  const refetchData = useCallback(() => {
    refetchTasks();
    refetchTasksCount();
  }, [refetchTasks, refetchTasksCount]);

  return {
    tasks,
    isLoading,
    tasksCount,
    refetchTasks,
    refetchTasksCount,
    refetchData,
  };
}
